import { useEffect, useState } from 'react';
import { initBuildMeta, subscribe, formatStamp } from '@/lib/buildMeta';

/**
 * Tiny footer text showing the running build commit + time.
 * Renders nothing if version.json is missing (e.g. fresh CRA dev with no
 * pre-build script run yet) — fail-quiet.
 */
export const BuildStamp = ({ className = '', testid = 'build-stamp' }) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    initBuildMeta();
    const unsub = subscribe(({ boot }) => setMeta(boot));
    return unsub;
  }, []);

  if (!meta) return null;
  const text = formatStamp(meta);
  if (!text) return null;
  return (
    <span
      data-testid={testid}
      className={`text-[10px] tracking-wide opacity-60 select-none ${className}`}
      title={`Branch: ${meta.branch || 'unknown'} · Built: ${meta.built_at || ''}`}
    >
      {text}
    </span>
  );
};

export default BuildStamp;
